import { ConversionResponse, ConversionService, UsdConversionResult } from './conversionService';
import ConversionServiceImplementation from './conversionServiceImplementation';

const conversionService: ConversionService = new ConversionServiceImplementation();

export default conversionService;
export type { UsdConversionResult as UsdConversionResponse, ConversionResponse as ConversionResult };
